import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getTemplateById = (data: PropertyType): Promise<PropertyType[]> =>
	api.post(`/user/report-filter-template`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
